import objectFitImages from 'object-fit-images';

var self = {};

self.initialise = function() {
  const someImages = document.querySelectorAll('.js-object-fit');
  setTimeout(() => {
    objectFitImages(someImages, { watchMQ: true });
  }, 100);
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-object-fit-polyfill.js